import { FCW } from '../../types.ts';
import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';

/**
 * Init Sentry
 */

const initializeSentry = () => {
  Sentry.init({
    dsn: 'https://268e5746bade4a738eb6f27bb44fef9c@sentry.services.dkms.org/4',
    release: window.__EREG_TELEMETRY__.release,
    environment: window.__EREG_TELEMETRY__.environment,
  });
};

export const SentryProvider: FCW = ({ children }) => {
  useEffect(() => {
    // @TODO Check why 'test' also gets a sentry
    if (window.__EREG_TELEMETRY__.environment === 'test' || window.__EREG_TELEMETRY__.environment === 'prod') {
      initializeSentry();
    }
  }, []);

  // No DOM changes, just the global import above.
  return <>{children}</>;
};
